import React, { useCallback, useContext, useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Divider,
  TextField,
  Box,
  Typography,
  Paper,
} from "@mui/material";
import EventBus from "../../utils/EventBus";
import HubEventNames from "../EventNames.js";
import UserContext from "../../auth/UserContext.js";

const HeaderRow = ({ label, children }) => (
  <Box
    sx={{
      display: "flex",
      alignItems: "center",
      py: 1,
      px: 1,
    }}
  >
    <Typography
      sx={{
        width: 80,
        color: "text.secondary",
        fontSize: 14,
      }}
    >
      {label}
    </Typography>
    <Box sx={{ flex: 1 }}>{children}</Box>
  </Box>
);

const SharePreviewDialog = () => {
  const userDetails = useContext(UserContext)
  const [open, setOpen] = useState(false);
  const [payload, setPayload] = useState(null);
  const [loading, setLoading] = useState(false)

  const openDialog = useCallback((payload) => {
    setPayload(payload);
    setOpen(true);
  }, []);

  const close = useCallback(() => {
    payload?.onClose?.();
    setLoading(false)
    setOpen(false);
  }, [payload]);

  const sendFinal = async () => {
    setLoading(true)
    await payload?.onSend();
    close()
  };

  const sendTest = async () => {
    setLoading(true)
    await payload?.onSendTest();
    close()
  };

  useEffect(() => {
    EventBus.on(
      HubEventNames.OPEN_SHARE_ARTICLE_PREVIEW_DIALOG,
      openDialog
    );
    EventBus.on(
      HubEventNames.CLOSE_SHARE_ARTICLE_PREVIEW_DIALOG,
      close
    );

    return () => {
      EventBus.removeListener(
        HubEventNames.OPEN_SHARE_ARTICLE_PREVIEW_DIALOG,
        openDialog
      );
      EventBus.removeListener(
        HubEventNames.CLOSE_SHARE_ARTICLE_PREVIEW_DIALOG,
        close
      );
    };
  }, [close, openDialog]);

  const recipientCount = payload?.emailList?.length || 0;

  return (
    <Dialog open={open} onClose={close} fullWidth maxWidth="md">
      <DialogTitle>
        Email Preview ({recipientCount} recipients)
      </DialogTitle>

      <DialogContent sx={{ px: 0 }}>
        {/* Email Header */}
        <Paper square elevation={0} sx={{ borderBottom: "1px solid #ddd", px: 2 }}>
          <HeaderRow label="From:">
            <Typography>
              noreply.tis@coca-cola.com
            </Typography>
          </HeaderRow>

          <Divider />

          <HeaderRow label="To:">
            <Typography>
              {userDetails.email}
            </Typography>
          </HeaderRow>

          <Divider />

          <HeaderRow label="Bcc:">
            <Typography>
              {recipientCount} recipients
            </Typography>
          </HeaderRow>

          <Divider />

          <HeaderRow label="Subject:">
            <Typography>
              {payload?.subject}
            </Typography>
          </HeaderRow>

        </Paper>

        {/* Email Body */}
        <Box
          sx={{
            px: 3,
            py: 2,
            minHeight: 320,
            backgroundColor: "#fff",
          }}
        >
          <Box
            sx={{ fontSize: 14 }}
            dangerouslySetInnerHTML={{
              __html: payload?.emailHTML,
            }}
          />
        </Box>
      </DialogContent>

      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={close} disabled={loading}>Cancel</Button>

        <Button
          variant="outlined"
          onClick={sendTest}
          disabled={!payload?.onSendTest || loading}
        >
          Send Test Email
        </Button>

        <Button variant="contained" onClick={sendFinal} disabled={loading}>
          Send Now
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SharePreviewDialog;